module.exports = __webpack_public_path__ + "static/media/02_thehighpriestess.31bc71d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/02_thehighpriestess.png
// module id = 65
// module chunks = 0